import NotFound404 from 'components/pages/NotFound404/NotFound404';
import { buildPage } from 'utils/pageHelper';

export default buildPage(NotFound404, {
  metaData: {
    title: '404 Not found',
    description: 'The page you are looking for was not found',
  },
});
